// Submit Survey

<template>
<div class="lms2000 container white curved">

  <div class="board">
    <Ul class="crumbs text-charcoal mb-2">
      <li><sym-link to="/">Home</sym-link></li>
      <li><sym-link to="lms1030">Portal</sym-link></li>
      <li><span aria-current="page">Submit Survey</span></li>
    </Ul>

    <div class="page-title lams curved border-lightgray mb-4">
      <h5 class="serif mb-0"><i class="fa fa-folder-o fa-lg ml-1 mr-2"></i>Submit Survey</h5>
    </div>

    <sym-alert class="lams-light border-main lg-2" icon="thumbs-o-up" dismissible v-show="step === 1 && availableRegions.length">
      <p class="mb-0">These regions are ready to accept your submission: </p>
      <hr class="separator">
      <ul class="avl-regions mb-2">
        <li v-for="region in availableRegions" :key="region.regionId"><b>{{ region.regionFullName }}</b></li>
      </ul>
    </sym-alert>

    <div v-show="step === 1">
      <p class="beige border-main lg-2 bold text-center p-2 curved"><span class="text-crimson">Step 1 of 2</span> - Upload DLSD File</p>

      <sym-upload
        class="lams-light border-main curved-1 p-1 shadow-light"
        inputClass="lams-light shadow"
        uploadButtonClass="success shadow"
        resetButtonClass="danger-light border-main shadow-light"
        iconClass="fa-file-o fa-fw fa-3x"
        :multiple="false"
        accept=".xml"
        instructions="Drag <span class='bold'>DLSD file</span> here <br>or click to browse"
        uploadButtonText="Click to Upload Now"
        :blinkUploadIcon="true"
        @select="onSelectDlsd"
        @upload="onUploadDlsd"
      >
      </sym-upload>

      <button type="button" class="primary text-center w-100 lg-1 shadow mt-3" @click="go('lms1030')"><i class="fa fa-arrow-left mr-2"></i> Back to GE Portal </button>

    </div>

    <div v-show="step === 2">
      <p class="beige border-main bold lg-2 text-center p-2 mb-0 curved-top"><span class="text-crimson">Step 2 of 2</span> - Upload Documents</p>

      <div class="floralwhite lg-2 border-main border-top-0 text-center curved-bottom p-2 mb-3" >
        <p class="w-100 mb-0">Files larger than {{ uploadMaxFileSizeText }} are NOT allowed.</p>
        <p class="mb-0">Survey plans must be in TIFF (Group 4) format with 300 dpi resolution.</p>
        <!-- <p class="mb-0">Other documents must be in PDF/A format.</p> -->
        <p class="mb-0">Other documents must be in PDF format.</p>
      </div>

      <sym-upload
        class="lams-light border-main curved-1 p-1 shadow-light mb-3"
        inputClass="lams-light shadow"
        uploadButtonClass="success shadow"
        resetButtonClass="danger-light border-main shadow-light"
        iconClass="fa-files-o fa-fw fa-3x"
        :multiple="true"
        accept=".tiff, .tif, .pdf"
        instructions="Drag documents here<br>or click to browse"
        uploadButtonText="Click to Upload Now"
        :blinkUploadIcon="true"
        @select="onSelectDocuments"
        @upload="onUploadDocuments"
        @selectedchanged="onSelectedChanged"
      >
      </sym-upload>

      <sym-card class="lams-light curved-1" headerClass="lg-1 text-center bold" bodyClass="p-1 pb-2" v-show="documentCount">
        <p slot="header" class="lg-2">Uploaded Documents </p>
        <ul>
          <li class="list-item text-dark" v-for="(doc, index) in documentNames" :key="index">
            <div class="d-flex justify-between align-items-center lg-1">
              <span>{{ doc.documentName }} ● {{ core.toPrettyFileSize(doc.fileSize) }}</span>
            </div>
          </li>
        </ul>
      </sym-card>

      <!-- <button
        type="button"
        class="success dark-4 lg-3 p-2 w-100 justify-center shadow-dark"
        @click="onSubmit"
        v-show="documentCount > 0"
      >
        <i class="fa fa-check fa-lg mr-2"></i>Submit / Get DLSD Number
     </button> -->

      <button
        type="button"
        class="success lg-3 p-2 w-100 justify-center shadow-dark"
        @click="onSubmit"
        v-show="documentCount > 0"
      >
        <i class="fa fa-check fa-lg mr-2"></i>Submit / Get DLSD Number
     </button>

    </div>

    <div class="dlsd-info" v-show="step === 3">
      <i></i>
      <sym-card class="lams-light border-main shadow">
        <p class="text-charcoal text-center bold display-8">DLSD Number</p>
        <p class="dlsd-number text-center bold display-6 curved">{{ dlsdInfo.id }}</p>

        <button type="button" class="warning text-center w-100 lg-2 shadow" @click="go('lms1030')"><i class="fa fa-arrow-left mr-2"></i> Back to GE Portal </button>
      </sym-card>
      <i></i>
    </div>

  </div>

  <sym-modal
    v-model="isModalVisible"
    size="rg"
    :header="true"
    :customBody="true"
    :footer="false"
    :keyboard="true"
    :dismissible="true"
    title="Upload Documents Result"
    v-if="isModalVisible"
    @show="onShowModal"
    headerClass="info-light"
    dismissButtonClass="danger"
  >

  <div class="white p-2 mb-0">
    <div class="mb-3" v-show="uploadedFiles.length">
      <p class="p-2 success mb-0 lg-2">Uploaded Files</p>
      <ul>
        <li class="list-item success-light" v-for="(doc, index) in uploadedFiles" :key="index">{{ doc.fileName }}</li>
      </ul>
    </div>

    <div v-show="rejectedFiles.length">
      <p class="p-2 danger mb-0 lg-2">Rejected Files</p>
      <ul>
        <li class="list-item danger-light" v-for="(doc, index) in rejectedFiles" :key="index">
          <p class="mb-1 bold lg-1">{{ doc.fileName }}</p>
          <p class="lg-2 text-crimson text-shadow mb-1"> {{ doc.statusText }} </p>
        </li>
      </ul>
    </div>
  </div>

  </sym-modal>

</div>
</template>

<script>

import
  * as lams
from '../../js/lams';

import {
  get,
  ajax,
  upload
} from '../../js/http';

import {
  appConfig
} from '../../js/session';

import
  PageBase
from '../PageBase.vue';

export default {
  extends: PageBase,
  name: 'lms2000',

  data () {
    return {
      step: 1,
      uploadMaxFileSizeText: '10 MB',

      dlsdInfo: {
        id: 0,
        fileName: '',
        regionId: 0,
        surveyorId: 0,
        subscriberId: 0,
      },

      selectedFileList: [],
      documentNames: [],            // uploaded files
      docsUploadResult: null,

      isModalVisible: false,
      availableRegions: [],
      surveys: [],
      profile: []

    };
  },

  computed: {
    documentCount () {
      return this.documentNames.length;
    },

    uploadedFiles () {
      return this.docsUploadResult.details.filter(o => o.statusCode === 201);
    },

    rejectedFiles () {
      return this.docsUploadResult.details.filter(o => o.statusCode !== 201);
    }
  },

  methods: {
    loadAcceptedDocuments () {
      const me = this;

      me.getDocuments().then(
        docNames => {
          me.documentNames = docNames;
        },
        fault => {
          me.showFault(fault);
        }
      )
    },

    // API calls

    getDlsdInfo (files) {
      
      return upload('api/dlsds/info/' + this.accountCode, files);
    },

    uploadDlsd (files) {
      const regionId = this.dlsdInfo.regionId;

      return upload('api/rgn/' + regionId + '/dlsds/upload/' + this.accountCode, files);
    },

    uploadDocuments (files) {
      const
        regionId = this.dlsdInfo.regionId,
        dlsdId = this.dlsdInfo.id;

      return upload('api/rgn/' + regionId + '/dlsds/' + dlsdId + '/documents', files);
    },

    getProfile () {
      return get('api/accounts/' + this.accountCode);
    },

    getSubmissions () {
      return get('api/rgn/' + this.dlsdInfo.regionId + '/dlsds/' +  this.dlsdInfo.id + '/submissions-details');
    },

    getDocuments () {
      const
        regionId = this.dlsdInfo.regionId,
        dlsdId = this.dlsdInfo.id;

      return get('api/rgn/' + regionId + '/dlsds/' + dlsdId + '/documents');
    },

    enlistSurveyor () {
      const
        me = this,
        info = me.dlsdInfo,
        options = me.core.getAjaxOptions('POST');

      let q = 'regionId=' + info.regionId + '&surveyorId=' + info.surveyorId + '&subscriberId=' + info.subscriberId;
      return ajax('api/accounts/' + me.accountCode + '/region-surveyor?' + q, options);
    },

    deleteDlsd () {
      const
        me = this,
        regionId = me.dlsdInfo.regionId,
        dlsdId = me.dlsdInfo.id,
        options = me.core.getAjaxOptions('DELETE');

      return ajax('api/rgn/' + regionId + '/dlsds//' + dlsdId, options);
    },


    sendMailNotification () {
      const
        me = this,
        toEmail = me.profile.validEmail,
        accountName = me.profile.accountName, 
        subject = 'Survey for ' + me.surveys.clientName,
        id = me.surveys.dlsdId,         
        message =   'Your Survey for ' + me.surveys.clientName + ' with DLSD ID ' + me.surveys.dlsdId + ' on ' + me.surveys.requestedLot + ', ' +  me.surveys.requestedLocation + ' is now submitted.',
        url = window.location.origin + '/my-surveys';

        // toEmail = me.appDetails.email,
        // accountName = me.appDetails.applicantName, 
        // subject =  me.appDetails.applicationTypeName,
        // id = me.smsAppId,
        // message = 'Your ' + me.appDetails.applicationTypeName + ' with Application ID ' + me.smsAppId + ' on lot ' + me.appDetails.lotNumber + ' Brgy ' +  me.appDetails.location + ' is now submitted',
        // url = window.location.origin + '/upload-documents?regionId=' + this.regionId + '&accountCode=' + me.sym.userInfo.accountCode + '&appId=' + me.smsAppId;


      let payload = {
        toEmail: toEmail,        
        accountName: accountName,
        subject: subject,        
        id: id,
        message: message,
        url: url
      };

      const
        body = JSON.stringify(payload),
        options = me.core.getAjaxOptions('POST', body);
      return ajax('api/rgn/' + me.dlsdInfo.regionId + '/mail/' + 2 + '/notification', options);
    },


    InsertSMS () {
      const
        me = this,
        toEmail = me.profile.email,
        accountName = me.profile.accountName, 
        subject = 'Survey for ' + me.surveys.clientName,
        id = me.surveys.dlsdId,         
        message =   'Your Survey for ' + me.surveys.clientName + ' with DLSD ID ' + me.surveys.dlsdId + ' on ' + me.surveys.requestedLot + ', ' +  me.surveys.requestedLocation + ' is now submitted.',
        phoneNumber = me.profile.validPhoneNumber1,
        url = window.location.origin + '/my-surveys';
 

      let payload = {
        toEmail: toEmail,        
        accountName: accountName,
        subject: subject,        
        id: id,
        message: message,
        phoneNumber: phoneNumber,
        url: url,
        regionId: this.regionId

      };

      const
        body = JSON.stringify(payload),
        options = me.core.getAjaxOptions('POST', body);
        // console.log('api/rgn/' + me.dlsdInfo.regionId + '/sms/' + this.surveys.dlsdId + '/notification',options);
      return ajax('api/rgn/' + me.dlsdInfo.regionId + '/sms/' + this.surveys.dlsdId + '/notification',options);
    },


    // event handlers

    onShowModal () {
    },

    onSelectDlsd (e) {
      const me = this;

      e.callback = me.onSelectCallback;

    },

    onSelectCallback (e) {
      const
        me = this,
        wait = me.wait();

      return me.getDlsdInfo(e.files)
        .then( data => {
          me.stopWait(wait);
          
          if (data) {
            if (data.surveyInfo) {
              let surveyInfo = data.surveyInfo;
              let regionInfo = lams.getRegionInfoByCode(surveyInfo.regionCode);

              me.dlsdInfo.surveyorId = surveyInfo.surveyorId;
              me.dlsdInfo.subscriberId = surveyInfo.subscriberId;

              if (regionInfo) {
                surveyInfo.regionName = regionInfo.regionFullName;
                me.dlsdInfo.regionId = regionInfo.regionId;
              }

              let html = `
                <p class="mb-0">Contents of selected DLSD file:</p>
                <p class="bold">${data.details[0].fileName}</p>
                <ul class="text-charcoal survey-info mb-3">
                  <li class="list-item p-2">
                    <p class="-mt-2 mb-1 bold"><small>Region</small></p>
                    <p class="info-value"> ${surveyInfo.regionName} </p>
                  </li>
                  <li class="list-item p-2">
                    <p class="-mt-2 mb-1 bold"><small>Requested Location</small></p>
                    <p class="info-value"> ${surveyInfo.requestedLocation} </p>
                  </li>
                  <li class="list-item p-2">
                    <p class="-mt-2 mb-1 bold"><small>Requested Lot</small></p>
                    <p class="info-value"> ${surveyInfo.requestedLot} </p>
                  </li>
                  <li class="list-item p-2">
                    <p class="-mt-2 mb-1 bold"><small>Survey Owner</small></p>
                    <p class="info-value"> ${surveyInfo.surveyOwner} </p>
                  </li>
                  <li class="list-item p-2">
                    <p class="-mt-2 mb-1 bold"><small>Geodetic Engineer</small></p>
                    <p class="info-value"> ${surveyInfo.surveyorName} </p>
                  </li>
                </ul>
                <p class="d-flex align-items-center"><i class="fa fa-exclamation-circle fa-2x text-info"></i><span class="ml-2" >Is this the correct DLSD file?</span></p>
              `;
              return me.dialog.confirm(html, { icon: 'none', backdrop: false });
            } else {
              let detail = data.details[0];
              let headerText = detail.statusCode === 503 ? 'DLSD file not processed.' : 'DLSD file rejected.';
              let html = headerText + '<br><br><b>' + detail.fileName + '</b><hr><span class="text-charcoal">' + detail.statusText + '</span>';
              return me.dialog.fault(html);
            }
          } else {
            let html = 'Problem encountered while handling DLSD file.<br><br><b>' + e.files[0].name + '</b><hr><span class="text-charcoal">You may try the upload again later.</span>';
            return me.dialog.fault(html);
          }
        })
        .then( reply => {
          return reply === 'yes';
        })
        .catch( fault => {
          me.stopWait(wait);
          me.showFault(fault);
          return false;
        });

    },

    onUploadDlsd (e) {
      const me = this;

      if (!me.dlsdInfo || !me.dlsdInfo.regionId) {
        return;
      }

      let wait = me.wait();

      me.uploadDlsd(e.fileList)
        .then( info => {
          me.stopWait(wait);
          // e.reset();
          // e.showUploadResponse(info)
          //   .then( () => {
          //     // me.loadData();
          //   });

          e.reset();

          if (info.createdCount) {
            me.dlsdInfo.id = info.dlsdId;
            me.dlsdInfo.fileName = info.details[0].fileName;
          }

          me.showUploadDlsdResponse(info).then(
            () => {
              me.step = 2;
            });
        })
        .catch( fault => {
          me.stopWait(wait);
          e.reset();
          me.showFault(fault);
        });

    },

    showUploadDlsdResponse (info) {
      if (!info || (!info.createdCount && !info.failedCount)) {
        return Promise.resolve();
      }

      let
        detail = info.details[0],
        html = '';

      if (info.createdCount) {
        html = 'DLSD file uploaded.<hr><b>' + detail.fileName + '</b><br><br>Next step is uploading of supporting documents.';
        return this.dialog.success(html);
      } else {
        html = 'DLSD file rejected.<br><br><b>' + detail.fileName + '</b><hr><span class="text-charcoal">' + detail.statusText + '</span>';
        return this.dialog.fault(html);
      }
    },

    onSelectDocuments (e) {
      const me = this;

      // testing for file size limit as set in AppConfig.json
      // loop in reverse, so splice works

      if (appConfig.uploadMaxFileSize) {
        for (let i = e.files.length - 1; i >= 0; i--) {
          if (e.files[i].size > appConfig.uploadMaxFileSize) {
            let mssg = 'File rejected. (' + e.files[i].name + ')<hr>Maximum file size is ' + appConfig.uploadMaxFileSizeText;
            this.advice.fault(mssg, 10);
            e.files.splice(i, 1);
          }
        }
      }

      //
      // omit files already uploaded
      //
      if (e.files.length && this.documentNames.length) {
        for (let i = e.files.length - 1; i >= 0; i--) {
          if (me.documentNames.findIndex(obj => obj.documentName === e.files[i].name) > -1) {
            let mssg = 'File omitted; already uploaded.<hr>' + e.files[i].name;
            me.advice.fault(mssg, 8);
            e.files.splice(i, 1);
          }
        }
      }

    },

    onUploadDocuments (e) {
      const
        me = this,
        wait = me.wait();

      me.uploadDocuments(e.fileList)
        .then( info => {
          me.stopWait(wait);

          e.reset();
          // e.showUploadResponse(info)
          //   .then( () => {
          //     // me.loadData();
          //   });

          me.showUploadDocumentsResponse(info)
            .then( () => {
              me.loadAcceptedDocuments();
            });

        })
        .catch( fault => {
          me.stopWait(wait);
          e.reset();
          me.showFault(fault);
        });

    },

    showUploadDocumentsResponse (info) {
      if (!info || (!info.createdCount && !info.failedCount)) {
        return Promise.resolve();
      }

      this.docsUploadResult = info;

      setTimeout(() => {
        this.isModalVisible = true;
      }, 200);

      return Promise.resolve();
    },

    onSelectedChanged (fileList) {
      this.selectedFileList = fileList;
    },

    onSubmit () {
      const me = this;

      me.enlistSurveyor().then(
        () => {
          let html = 'Thank you for submitting your survey plans/returns. Please take note of your DLSD ID. The transaction number will be sent to you thru SMS once your submittal is accepted or processed.'
          me.dialog.success(html).then(
            () => {

              me.getProfile().then(
                info => {
                  if (info) {
                    me.profile = info[0];
                    me.getSubmissions().then(
                      surveys => {
                        me.surveys = surveys[0];  
                        
                        
                        if (me.profile.validEmail) {
                          me.sendMailNotification(); 
                        }                    
                        if (me.profile.validPhoneNumber1) {
                          me.InsertSMS();
                        }    
                      },
                      fault => {
                        me.showFault(fault);
                      }
                    );
                  }
                },
                fault => {
                  me.showFault(fault);
                }
              );
              me.step = 3;
            }
          );
        },
        fault => {
          me.showFault(fault);
        }
      );

    },

  },

  created () {
    this.accountCode = '';
  },

  mounted () {
    const me = this;

    me.accountCode = me.sym.userInfo.accountCode,
    me.uploadMaxFileSizeText = appConfig.uploadMaxFileSizeText;

    me.availableRegions = lams.getRegionList().filter(o => o.apiHostAddress);

  },

  beforeRouteLeave (to, from, next) {
    const
      me = this,
      info = me.dlsdInfo;

    if (me.step === 2 && !me.documentNames.length && info.regionId && info.id) {
      me.deleteDlsd().then(
        () => {
          next();
        },
        () => {
          next();
        }
      );
    } else {
      next();
    }
  }

}

</script>

<style>

.survey-info .info-value {
  color: brown;
  margin-bottom: 0;
  font-size: 1rem;
  line-height: .9;
}

.survey-info .list-item{
  background: linen;
}

</style>

<style scoped>

/* .lms2000 {
  min-height: calc(100vh - 90px - 2rem) ;
} */

.page-title {
  padding: .875rem;
}

.dlsd-info {
  display: grid;
  grid-template-columns: 1fr 3fr 1fr;
}

.dlsd-number {
  color: seagreen;
  border: 2px solid seagreen;
  background: whitesmoke;
  padding: .5rem;
}

.avl-regions {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(3, 1fr);
}

.avl-regions li {
  margin-left: 1.25rem;
  line-height: .5;
}

.separator {
  margin-bottom: 1rem;
}

.alert.fade-enter-active {
  transition: opacity 1s;
}

.alert.fade-leave-active {
  transition: opacity .5s;
}

@media (max-width: 1048px) {
  .avl-regions {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 650px) {
  .avl-regions {
    grid-template-columns: 1fr;
  }
}

/* @media (max-width: 576px) {
  .lms2000 {
    min-height: calc(100vh - 84px) ;
  }
} */

@media (max-width: 480px) {
  .page-title {
    padding: .6875rem;
  }

  .dlsd-info {
    grid-template-columns: 1fr 6fr 1fr;
  }
}

@media (max-width: 384px) {
  .page-title {
    padding: .5rem;
  }

  .dlsd-info {
    grid-template-columns: 1fr 10fr 1fr;
  }

}

</style>